import { ClbCard } from '@celebration/react/ClbCard/ClbCard';
import './card.scss';

export default ClbCard;
